import { api as ratingApi } from './auto-generated/rating'

ratingApi.enhanceEndpoints({
  endpoints: {},
})

export { ratingApi }
